import { Icon, TextLink } from "@moneyforward/mfx_biz_react_components";
import { css } from "@emotion/react";
import { BannerVariant } from "@/libs/hooks/useMigratePrompt";

export type MigrationBannerVariant =
  | NonNullable<BannerVariant>
  | "migration-complete"
  | "migration-failed";

type Props = {
  variant: MigrationBannerVariant;
  onClose: () => void;
};

const bannerStyle = css({
  display: "flex",
  gap: "8px",
  padding: "10px 16px",
  backgroundColor: "#EBF5FF",
  fontSize: "14px",
  lineHeight: "1.5",
  marginBottom: "8px",
});

const textStyle = css({ flex: 1 });

const closeStyle = css({
  background: "none",
  border: "none",
  padding: 0,
  display: "flex",
});

const baseUpgradeText =
  "セキュリティ向上と機能改善のため、すべてのユーザーアカウントを最新システムへのアップグレードをお願いいたします。";

export const messages: Record<
  MigrationBannerVariant,
  { text: string; showLink: boolean }
> = {
  "upgrade-admin": {
    text: `${baseUpgradeText}移行する処理は数秒で完了し、現在の設定やデータはすべて維持されます。`,
    showLink: true,
  },
  "restart-migrate": {
    text: "一部のユーザーの移行が失敗したため、最新システムへの移行はまだ完了していません。移行を再開してください。",
    showLink: true,
  },
  "before-migrate": {
    text: `${baseUpgradeText}移行作業は、契約管理者のみ行うことができます。契約管理者にご確認ください。`,
    showLink: false,
  },
  "migration-complete": {
    text: "すべてのユーザーの移行が完了しました。移行ステータスが反映されない場合は、画面を更新してください。",
    showLink: false,
  },
  "migration-failed": {
    text: "ユーザー情報の移行が中断されました。画面を更新して最新の移行ステータスを確認してください。移行が完了していない場合、1～2分後に再度移行をお試しください。",
    showLink: false,
  },
};

export const MigrationBanner = ({ variant, onClose }: Props) => {
  const { text, showLink } = messages[variant];

  return (
    <div css={bannerStyle}>
      <span css={textStyle}>
        {text}
        {showLink && <TextLink href="/migrate-users">　移行画面へ</TextLink>}
      </span>
      <button css={closeStyle} onClick={onClose} aria-label="閉じる">
        <Icon style={{ cursor: "pointer" }} name="close" size="md" />
      </button>
    </div>
  );
};
